<template>
    <div class="tinted-image" :class="[bemFacet]">
        <button class="tinted-image--button"
                :disabled="isInert ? true : null"
                @click.prevent="onSelectedHandler()">
            <img :src="img.url" class="tinted-image--img tinted-image--img__fallback"/>
            <svg width="16" height="9" viewBox="0 0 16 9" version="1.1"
                    xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"
                    class="tinted-image--thumb" role="img" :aria-label="img.alt">
                <image :xlink:href="img.url" filter="url(#svg-filter-source-grayscale)"
                        width="100%" height="100%"
                        class="tinted-image--img tinted-image--img__bw"/>
                <image :xlink:href="img.url"
                        width="100%" height="100%"
                        class="tinted-image--img tinted-image--img__color"/>
            </svg>
        </button>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';


    export default {
        mixins: [
            bemMixin('tinted-image'),
        ],
        props: {
            isInert: {
                type: Boolean,
                default: true,
            },
            img: {
                type: Object,
                required: true,
            },
        },
        methods: {
            onSelectedHandler() {
                if (this.isInert) {
                    return;
                }

                this.$emit('request-action');
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/tinted-image/index.vue?5adc34c8